var map = {
	"./": 142,
	"./Clutch": 2696,
	"./Clutch.js": 2696,
	"./NewUi": 2697,
	"./NewUi.js": 2697,
	"./OldUi": 2698,
	"./OldUi.js": 2698,
	"./index": 142,
	"./index.js": 142,
	"./style": 864,
	"./style.js": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4223;